import { RestaurantPropType } from "../types";
import Favorite from "../../../utils/apiServices/favourite";
import { useSelector, useDispatch } from "react-redux";
import { IRootState } from "../../..";
import FavouriteButton from "../../favourites/component/FavouriteButton";
import notify from "../../../utils/notify";
import { toggleFavorite } from "../reducer";

type PropType = {
  restaurant: RestaurantPropType;
  onClick: (restaurant: RestaurantPropType) => void;
};

const TopItemCard = ({ onClick, restaurant }: PropType) => {
  const averageRating = restaurant.establishment_ratings.length >0 ? restaurant.establishment_ratings.reduce(
    (acc, curr) => acc + curr.rating, 0) / restaurant.establishment_ratings.length : 0;
  const user = useSelector((state: IRootState) => state.user.value);
  const { loggedIn } = user;
  const dispatch = useDispatch();
  const onToggleFavorite = () => {
    if (loggedIn) {
      if (restaurant.isFavourite) {
        Favorite.deleteFavoriteEstablishment(restaurant.id)
          .then((res) => {
            if (res.success) {
            } else {
              notify("error", res.mesage);
            }
          })
          .catch(() => {
            
          });
      } else {
        Favorite.addFavorite({
          type: "ESTABLISHMENT",
          wishlist: restaurant.id,
        })
          .then((res) => {
            if (res.success) {
            } else {
              notify("error", res.message);
            }
          })
          .catch(() => {
            
          });
      }
      dispatch(toggleFavorite(restaurant.id));
    } else {
      notify("error", "Please login to add to favourite");
    }
  };
  return (
    <div className="relative rounded-lg p-2 flex items-start gap-2 bg-white justify-between">
      {restaurant!.is_open === false && (
        <div className="absolute rounded-lg flex items-center justify-center top-0 bottom-0 left-0 right-0 bg-trans">
          <div className="font-medium text-base text-white">
            Temporarily Closed
          </div>
        </div>
      )}
      <div
        className="flex gap-2 whitespace-nowrap w-full"
        onClick={() => onClick(restaurant)}
      >
        <div
          className="w-[80px] bg-grey bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${restaurant.cover_photo})` }}
        ></div>
        <div className="flex flex-col gap-2">
          <div className="text-sm font-medium">{restaurant.name}</div>
          <div className="text-[#727272] font-medium text-xs flex items-center gap-x-2">
          <div className="flex items-center gap-x-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <div
                  key={star}
                  className={`text-xl cursor-pointer ${
                    star <= averageRating
                      ? "text-yellow-500"
                      : "text-[#DADADA]"
                  }`}
                >
                  <span className="star ">&#9733;</span>
                </div>
              ))}
            </div>
            {averageRating.toPrecision(2)}
            </div>
          <div className="text-blue font-normal text-xs bg-blue/5 p-2 w-fit">
            {restaurant.delivery_time} mins
          </div>
        </div>
      </div>
      <FavouriteButton
        onToggle={onToggleFavorite}
        isFav={restaurant.isFavourite}
      />
    </div>
  );
};

export default TopItemCard;
